import { combineReducers } from 'redux';

import token from './tokenReducer'
import notification from './notificationReducer'

export default combineReducers({ token, notification });
